import { useEffect, useRef, useState } from 'react';
import mermaid from 'mermaid';

mermaid.initialize({
  startOnLoad: false,
  theme: 'dark',
  securityLevel: 'loose',
});

export function Mermaid({ chart }: { chart: string }) {
  const ref = useRef<HTMLDivElement>(null);
  const [svgContent, setSvgContent] = useState<string>('');

  useEffect(() => {
    let isMounted = true;
    
    const renderChart = async () => {
      try {
        const id = `mermaid-svg-${Math.random().toString(36).substring(2, 9)}`;
        const { svg } = await mermaid.render(id, chart);
        if (isMounted) {
          setSvgContent(svg);
        }
      } catch (error) {
        console.error("Mermaid syntax error:", error);
        if (isMounted) {
          setSvgContent(`<div style="color: red; padding: 10px;">Error rendering diagram. Check console for details.</div><pre style="font-size: 10px;">${chart}</pre>`);
        }
      }
    };

    if (chart) {
      renderChart();
    }

    return () => {
      isMounted = false;
    };
  }, [chart]);

  return (
    <div 
      ref={ref} 
      className="mermaid-container" 
      style={{ 
        margin: '16px 0', 
        background: 'var(--panel)', 
        padding: '16px', 
        borderRadius: '8px',
        overflowX: 'auto',
        display: 'flex',
        justifyContent: 'center'
      }}
      dangerouslySetInnerHTML={{ __html: svgContent }}
    />
  );
}
